import {
  doClusterSearch,
  hideClusterListLoading,
  showClusterListLoading,
  updateClusterList,
} from './clusterlist.actions';
import { Action } from 'redux';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { isType } from 'typescript-fsa';
import { LOCATION_CHANGE } from 'react-router-redux';
import { Pagination } from '../../components/Pagination/index';
import { AppState } from '../reducers';
import { getClustersByIds } from '../Entities/Clusters/clusters.reducer';
import { getQueryParameter } from '../../utils/url';
import { getStoriesByIds } from '../Entities/Stories/stories.reducer';

interface ClusterList {
  clusterIds?: number[];
  pagination?: Pagination;
  searchQuery?: string;
  country: string;
  loading: boolean;
}
export type ClusterListState = ClusterList & ImmutableObject<ClusterList>;

const initialState = Immutable.from<ClusterList>({
  clusterIds: void 0,
  country: 'de',
  loading: true,
});

export interface ClusterResult {
  entities: {
    cluster: object;
  };
  result: {
    meta: object;
    data: object;
  };
}

export default function reduce(
  state: ClusterListState = initialState,
  action: Action
) {
  if (isType(action, updateClusterList)) {
    const { clusterIds, pagination } = action.payload;

    return state.merge({ clusterIds, pagination });
  }

  if (isType(action, doClusterSearch)) {
    const { query } = action.payload;
    return state.merge({
      searchQuery: query,
      pagination: {} as Pagination,
    });
  }

  if (isType(action, showClusterListLoading)) {
    return state.merge({ loading: true });
  }

  if (isType(action, hideClusterListLoading)) {
    return state.merge({ loading: false });
  }

  if (action.type === LOCATION_CHANGE) {
    const { search, pathname } = (action as any).payload;
    if (pathname !== '/clusters') {
      return state;
    }

    return state.merge({
      pagination: {
        ...state.pagination,
        currentPage: getQueryParameter('page', search, 1),
      },
      searchQuery: getQueryParameter('filter[search]', search),
      country: getQueryParameter('country', search, state.country),
    });
  }

  return state;
}

export function getCountry(state: AppState) {
  const {
    clusterList: { country },
  } = state;

  return country;
}

export function getClusters(state: AppState) {
  const {
    clusterList: { clusterIds },
  } = state;
  const clusters = getClustersByIds(state, clusterIds || []);

  return (
    clusters &&
    clusters.map(cluster => {
      return {
        ...cluster,
        stories: cluster && getStoriesByIds(state, cluster.stories as number[]),
      };
    })
  );
}

export function getPagination(state: AppState) {
  const {
    clusterList: { pagination },
  } = state as any;

  return pagination;
}

export function getSearchQuery(state: AppState) {
  const {
    clusterList: { searchQuery },
  } = state as any;

  return searchQuery;
}

export function getClusterListLoading(state: AppState) {
  const {
    clusterList: { loading },
  } = state;
  return loading;
}



// WEBPACK FOOTER //
// ./src/store/ClusterList/clusterlist.reducer.ts